/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import React from 'react'
import TableX from 'DesignSystem/TableX/react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Onboarding/Inputs/Content",
  value
  
}) {
  return (<React.Fragment
>
<TableX
  viewPath={`${viewPath}/TableX`}
 value={value}
/>
{children}
</React.Fragment>)
}